var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'botao-padrao',
    { 'arredondado-esquerda': _vm.arredondadoEsquerda },
    { 'arredondado-direita': _vm.arredondadoDireita },
    { arredondado: _vm.arredondado },
    { desabilita: _vm.desabilita },
    _vm.cor ? _vm.cor : ''
  ],attrs:{"disabled":_vm.desabilita}},[_vm._v("\n  "+_vm._s(_vm.nome.toUpperCase())+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }